import { render, staticRenderFns } from "./userDropdown.vue?vue&type=template&id=35782840&scoped=true"
import script from "./userDropdown.vue?vue&type=script&lang=js"
export * from "./userDropdown.vue?vue&type=script&lang=js"
import style0 from "./userDropdown.vue?vue&type=style&index=0&id=35782840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35782840",
  null
  
)

export default component.exports